import { cn } from "utils/commonUtils";


export default function ModalDialog({ className = "", children }) {
    return (
        <div
            className={` modal-dialog ${cn(
                " tw-max-w-full sm:tw-max-w-[calc(100vw-20px)] md:tw-max-w-[600px] tw-relative tw-m-auto tw-transform-none tw-mt-0 sm:tw-mt-12 tw-pt-0 sm:tw-pt-12",
                className
            )} `}
        >
            {children}
        </div>
    );
}
